/* eslint-disable no-unused-vars, no-return-assign */
/* Commerce Utilities for connecting to Magento GraphQL & Rest Services */

const CommerceJP = (() => {
	let baseURL = 'https://uat-shop.batj.jp/shop/graphql';

	if (typeof graphql !== 'undefined') {
		baseURL = graphql;
	}

	const cartUpdate = $.Event('cart-update');
	const cartAction = $.Event('cart-action');
	const cartError = $.Event('cart-error');

	let lastItemAdded = '';
	let lastActionTaken = '';

	const credentials = {
		INCLUDE: 'include',
		SAMEORIGIN: 'same-origin',
	};

	// private method(s)
	const _constructor = () => {
		/* eslint-disable-next-line no-use-before-define */
		_cartCookieCheck();
	};

	// Check for cart cookie
	const _cartCookieCheck = () => {
		const cartCookie = document.cookie.match(
			`(^|;) ?commerce-cart-id=([^;]*)(;|$)`
		);
		const cartData = localStorage.getItem('commerce-cart-storage');

		// Clear local cart storage if no cart cookie is found.
		if (!cartCookie && cartData) {
			localStorage.removeItem('commerce-cart-storage');
		}
	};

	// Fetch GET Request
	const _makeGetRequest = async (query, variables, creds) => {
		// Clean strings of new lines and unnecessary space
		const queryString = query.replace(/\s\s+/g, ' ');
		const variablesString = variables ?
			variables.replace(/\s\s+/g, ' ') :
			'';

		const queryEncodeString = `?query=${encodeURIComponent(queryString)}`;
		const variablesEncodeString = `&variables=${encodeURIComponent(
			variablesString
		)}`;
		const url =
			baseURL +
			queryEncodeString +
			(variables ? variablesEncodeString : '');

		const request = await fetch(url, {
			method: 'GET',
			credentials: creds || credentials.SAMEORIGIN,
			headers: {
				'Content-Type': 'application/json',
				store: 'glo_jp_ja_jp',
			},
		})
			.then((response) => response.json())
			.then((response) => {
				// Console error messages and return
				if (response.errors && response.errors.length) {
					response.errors.map((error) => {
						/* eslint-disable-next-line no-console */
						console.log('Response failed: ', error.message);
						return false;
					});
				}

				return response;
			})
			.catch((error) => {
				/* eslint-disable-next-line no-console */
				console.log('Request failed: ', error);
			});

		return request;
	};

	// Fetch POST Request
	const _makePostRequest = async (query, creds) => {
		const request = await fetch(baseURL, {
			method: 'POST',
			credentials: creds || credentials.SAMEORIGIN,
			headers: {
				'Content-Type': 'application/json',
				store: 'glo_jp_ja_jp',
			},
			body: query,
		})
			.then((response) => response.json())
			.then((response) => {
				// Console error messages and return
				if (response.errors && response.errors.length) {
					response.errors.map((error) => {
						/* eslint-disable-next-line no-console */
						console.log('Response failed: ', error.message);
						return false;
					});
				}

				return response;
			})
			.catch((error) => {
				/* eslint-disable-next-line no-console */
				console.log('Request failed: ', error);
			});

		return request;
	};

	const _getCategoryList = async (categoryId) => {
		const requestBody = `{
			categoryList (
				filters: {
					ids: {
						eq: "${categoryId}"
					}
				}
			) {
				${categoryListInterface}
			}
			
		}`;

		const request = await _makeGetRequest(requestBody, "", credentials.INCLUDE).then((response) => {
			Utils.setLocalStorage('commerce-product-storage', response);
			return response;
		});

		return request;
	};

	// Get Product Catalog
	const _getProductCatalog = async (
		categoryIds,
		filterProps,
		productSKU,
		currentPage,
		pageSize,
		sortParam,
		priceRange,
		searchString,
		dataSourceConfigured,
		source
	) => {
		let productPropertiesAttributes, relatedProductAttributes, customProductPropertiesAttributes, configurableAttributes, bundleAttributes;
		createCategoriesString = (categories) => {
			let string = '';
			let el = '';
			if (categories) {
				categories.forEach((category) => (string += `"${category}",`));

				if (string.split(",").length - 1 === 1) {
					el = 'eq';
				} else {
					string = `[${string}]`;
					el = 'in';
				}
				return `
					category_id: {
						${el}: ${string}
					}
				`;
			}
			return string;
		};

		createPropertiesString = (properties) => {
			let string = '';
			if (properties) {
				const propertiesObject = !!properties &&
					properties.reduce((acc, cur) => {
						return !acc[cur.filterProp] ? {
							...acc,
							[cur.filterProp]: `"${cur.filterValue}",`,
						} : {
							...acc,
							[cur.filterProp]: (acc[
								cur.filterProp
								] += `"${cur.filterValue}",`),
						};
					}, {});
				Object.keys(propertiesObject).forEach(
					(key) =>
						(string += `${key}: { in: [${propertiesObject[key]}] }`)
				);
			}
			return string;
		};

		createSKUstring = (sku) => {
			let string = '';
			if (sku) {
				string = `sku: {eq: "${sku}"}`;
			}
			return string;
		};

		createPriceRangeString = () => {
			let string = '';
			if (priceRange) {
				string = `
					price: {
						from: "${priceRange.from}"
						to: "${priceRange.to}"
					}
				`;
			}
			return string;
		};

		createSearchString = () => {
			let string = '';
			if (searchString) {
				string = `search: "${searchString}"`;
			}
			return string;
		};
		productPropertiesAttributes = source && source === 'plp'? productPropertiesInterfacePLP:productPropertiesInterface;
		customProductPropertiesAttributes = source && source === 'plp'? customProductPropertiesInterfacePLP: customProductPropertiesInterface;
		configurableAttributes = source && source === 'plp'? configurableInterfacePLP: configurableInterface;
		bundleAttributes = source && source === 'plp'? bundleInterfacePLP: bundleInterface;
		relatedProductAttributes =  dataSourceConfigured && dataSourceConfigured === "related_products" ? source && source == 'plp'?relatedProductsInterfacePLP:relatedProductsInterface:"";
		const requestBody = `{
				products(
					filter: {
						${createCategoriesString(categoryIds)}
						${createPropertiesString(filterProps)}
						${createSKUstring(productSKU)}
						${createPriceRangeString()}
					}
					${createSearchString()}
					${(sortParam && sortParam.sortProp && sortParam.sortDir) ? `sort : { ${sortParam.sortProp}:${sortParam.sortDir}}` : ''}
	
					currentPage: ${currentPage}
					pageSize: ${pageSize}
				) {
					items 	{
						${window.quizResultsAttributes !== undefined ? window.quizResultsAttributes : ''}
						${productPropertiesAttributes}
						${customProductPropertiesAttributes}
						${relatedProductAttributes}
						${configurableAttributes}
						${bundleAttributes}
					}
					total_count
					page_info {
						current_page
						page_size
						total_pages
					}
				}
			}`;
		

		const query = JSON.stringify({
			query: requestBody
		});
		const request = await _makeGetRequest(requestBody, "", credentials.INCLUDE).then((response) => {
			Utils.setLocalStorage('commerce-product-storage', response);
			return response;
		});

		// const request = await _makePostRequest(query).then((response) => {
		// 	Utils.setLocalStorage('commerce-product-storage', response);
		// 	return response;
		// });

		return request;
	};

	const _getStoreConfig = async () => {
		const requestBody = `{ storeConfig {
    		bat_barometer_config_values
    		}
		}`;
		const query = JSON.stringify({
			query: requestBody,
		});
		const request = await _makeGetRequest(requestBody, "", credentials.INCLUDE);


		// const query = JSON.stringify({
		// 	query: requestBody,
		// });
		//
		// const request = await _makeGetRequest(requestBody, "", credentials.INCLUDE);
		return request;
	};

	// Get One Product
	const _getProduct = async (productID) => {
		// Catch no productId.
		if (!productID) {
			return Promise.resolve('Need Product Id.');
		}
		const requestBody = `{
		    products(
		        filter: { sku: {eq: "${productID}"} }
		    ) {
		        items {
					${productPropertiesInterface}
					${customProductPropertiesInterface}
					${configurableInterface}
					${bundleInterface}
		        }
		    }
		}`;
		const query = JSON.stringify({
			query: requestBody
		});
		const request = await _makeGetRequest(requestBody, '', credentials.INCLUDE);

		// const request = await _makePostRequest(query, credentials.INCLUDE);
		return request;
	};

	/* Add Simple Product to Cart */
	const _addSimpleProduct = async (cartObject) => {
		// Catch no productId.
		if (!cartObject) {
			return Promise.resolve('Need Cart Object.');
		}
		let requestBody;
		let samplesObj = '';
		if (cartObject.sampleSku != '' && typeof cartObject.sampleSku !== 'undefined') {
			samplesObj = '{data: {quantity: 1 sku: "' + cartObject.sampleSku + '" }}';
		}
		if (cartObject.subscription_option_value === 'subscription') {
			requestBody = `mutation addSimpleProductToCart(
				$cartId: String!
				$sku: String!
				$quantity: Float!
				$subscription_option_value:String!
			) {
				addSimpleProductsToCart(
					input: {
						cart_id: $cartId
						cart_items: [{ data: { quantity: $quantity, sku: $sku }
							subscription_option: {
								option:$subscription_option_value
							}
						},
						${samplesObj}
						]
					}
				) {
					cart {
						items {
							id
							product {
								name
								sku
							}
							quantity
						}
					}
				}
			}`;
		} else {
			requestBody = `mutation addSimpleProductToCart(
				$cartId: String!
				$sku: String!
				$quantity: Float!
			) {
				addSimpleProductsToCart(
					input: {
						cart_id: $cartId
						cart_items: [{ data: { quantity: $quantity, sku: $sku } }, ${samplesObj}]
					}
				) {
					cart {
						items {
							id
							product {
								name
								sku
							}
							quantity
						}
					}
				}
			}`;
		}

		//subscription_option_value: cartObject.subscription_option_value,
		let variablesObj = {
			cartId: cartObject.cartId,
			sku: cartObject.productSku,
			quantity: cartObject.productQuantity,
		};

		if (cartObject.subscription_option_value === 'subscription') {
			variablesObj.subscription_option_value = cartObject.subscription_option_value;
		}

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequest(query, credentials.INCLUDE);
		return request;
	};

	/* Add Configurable Product to Cart */
	const _addConfigurableProduct = async (cartObject) => {
		// Catch no productId.
		if (!cartObject) {
			return Promise.resolve('Need Cart Object.');
		}

		const requestBody = `mutation addConfigurableProductToCart(
			$cartId: String!
			$parentSku: String!
			$sku: String!
			$quantity: Float!
		) {
			addConfigurableProductsToCart(
				input: {
					cart_id: $cartId
					cart_items: [
						{
							parent_id: $parentSku
							data: { quantity: $quantity, sku: $sku }
						}
					]
				}
			) {
				cart {
					items {
						id
						quantity
						product {
							name
							sku
						}
						... on ConfigurableCartItem {
							configurable_options {
								option_label
							}
						}
					}
				}
			}
		}`;

		const variablesObj = {
			cartId: cartObject.cartId,
			parentSku: cartObject.familySku,
			sku: cartObject.productSku,
			quantity: cartObject.productQuantity,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequest(query, credentials.INCLUDE);
		return request;
	};

	/* Add Bundle Product to Cart */
	const _addBundleProduct = async (cartObject) => {
		// Catch no productId.
		if (!cartObject) {
			return Promise.resolve('Need Cart Object.');
		}

		const requestBody = `mutation addBundleProductToCart(
			$cartId: String!
			$sku: String!
			$quantity: Float!
			$bundleOptions: [BundleOptionInput]!
		) {
			addBundleProductsToCart(
				input: {
					cart_id: $cartId
					cart_items: [
						{
							data: { sku: $sku, quantity: $quantity }
							bundle_options: $bundleOptions
						}
					]
				}
			) {
				cart {
					items {
						id
						quantity
						product {
							sku
						}
						... on BundleCartItem {
							bundle_options {
								id
								label
								type
								values {
									id
									label
									price
									quantity
								}
							}
						}
					}
				}
			}
		}`;

		const variablesObj = {
			cartId: cartObject.cartId,
			sku: cartObject.productSku,
			quantity: cartObject.productQuantity,
			bundleOptions: cartObject.bundleOptions,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequest(query, credentials.INCLUDE);

		return request;
	};

	/* Product Price Formatter */
	const _priceFormatter = (priceValue, priceType) => {
		let price = '';
		let brand = '';

		if (document.getElementsByTagName('meta').brandPage) {
			brand = document.getElementsByTagName('meta').brandPage.content;
		} else if (document.getElementsByTagName('meta').brandPLP) {
			brand = document.getElementsByTagName('meta').brandPLP.content;
		} else if (document.getElementsByTagName('meta').brandPDP) {
			brand = document.getElementsByTagName('meta').brandPDP.content;
		}

		switch (priceType) {
			case 'USD':
				price = `$${priceValue}`;
				break;
			case 'GBP':
				price = `&#163;${priceValue}`;
				break;
			case 'EUR':
				price = `€${priceValue}`;
				break;
			case 'JPY':
				brand === 'velo' ? price = `${Utils.toCommas(priceValue)}円` : price = `${Utils.toCommas(priceValue)}円 (税込)`; // //(税込)
				// price = `${Utils.toCommas(priceValue)}円`; //(税込)
				break;
			default:
				price = priceValue;
		}

		return price;
	};

	/* Get Cart */
	const _getCart = async (cartId, reload = true) => {
		let isLoggedIn = _isLoggedIn();
		let localCart = $.parseJSON(Utils.getLocalStorage('commerce-cart-storage'));
		let shouldReplaceCarts = isLoggedIn && Utils.getCookie('local-cart') && localCart && localCart.data.cart.items.length !== 0 && Utils.getCookie('commerce-cart-id') !== null;

		if (shouldReplaceCarts && !window.location.href.includes('/shop')) {
			await _replaceCommerceCart(Utils.getCookie('commerce-cart-id'));

		} else if (isLoggedIn && localCart && localCart.data.cart.items.length === 0) {

			Utils.eraseCookie('commerce-cart-id');
			Utils.removeLocalStorage('commerce-cart-storage');
			Utils.eraseCookie('local-cart');
		}

		let shouldUseLocalCart = window.shouldBeVisible && !isLoggedIn;

		const requestCallback = (response) => {
			if (response.data?.hasOwnProperty('customerCart')) {
				response.data.cart = response.data.customerCart;
				delete response.data.customerCart;
			}
			
			Utils.setCookie('commerce-cart-id', response.data?.cart.id, 1, 'Lax');
			// Add info on user action for messagebar
			response.lastItemAdded = lastItemAdded;
			response.lastActionTaken = lastActionTaken;
			response.data.cart.items = response.data?.cart.items.filter((item) => item !== null);
			Utils.setLocalStorage('commerce-cart-storage', response);
			
			// Trigger cart update window event
			if (reload) {
				$(window).trigger(cartUpdate);
			}
			return response;
		};
		let request;

		let requestBody = '';
		if (!shouldUseLocalCart) {
			requestBody = `{
			  customerCart {
			    id
			    ${cartInterface}
			  }
			}`;
			const query = JSON.stringify({
				query: requestBody,
			});
			request = await _makePostRequest(query, credentials.INCLUDE).then(requestCallback);

		} else {
			console.log("Anonymous Cart in use");

			while (Utils.getCookie('commerce-cart-id') == null) {
				await new Promise(r => setTimeout(r, 500));
			}

			let localCartId = Utils.getCookie('commerce-cart-id');
			requestBody = `{
		  				cart(cart_id: "${localCartId}") {
							id
							${cartInterface}
						}
					}`;
			const query = JSON.stringify({
				query: requestBody,
			});
			request = await _makePostRequest(query, credentials.INCLUDE).then(requestCallback);


		}

		return request;
	};
	/* Merge local and remote carts */
	const _replaceCommerceCart = async (guestCartId) => {
		const requestBody = `mutation {
								assignGuestCartToCustomer(
									input: {
										cart_id: "${guestCartId}"
									}
								) {
									 cart {
										items {
											id
											quantity
											product {
												sku
												stock_status
											}
										}
									}
									error_messages {
										message
									}
								}
							}`;


		const query = JSON.stringify({
			query: requestBody,
		});

		const request = await _makePostRequest(query).then((response) => {
			return response.data;
		});
		Utils.eraseCookie('local-cart');
		Utils.removeLocalStorage('commerce-cart-storage');
		Utils.eraseCookie('commerce-cart-id');

		if (request && request.errors) {
			$(window).trigger(cartError, request.errors[0].message);
			return request;
		}

		return request;
	};

	/* Get Cart Id on page load */
	const _getCartId = async (cartId) => {
		let isLoggedIn = _isLoggedIn();
		let shouldUseLocalCart = window.shouldBeVisible && !isLoggedIn;
		let requestBody = '';
		const refreshFlag = Utils.getLocalStorage('refresh-flag');

		const afterRequestSteps = (response) => {
			if (response.data?.hasOwnProperty('customerCart')) {
				response.data.cart = response.data.customerCart;
				delete response.data.customerCart;
			}
			if (response.data?.cart !== null) {
				const cartsCookie = Utils.getCookie('commerce-cart-id');
				const cartId = response.data?.cart.id;
				Utils.removeLocalStorage('refresh-flag');
				if (cartsCookie && cartId && cartsCookie !== cartId) {
					_getCart(cartId);
				}
			} else {
				if (!refreshFlag) {
					Utils.setLocalStorage('refresh-flag', true);
					const isAuthorMode = Utils.getCookie('cq-authoring-mode');
					!isAuthorMode && window.location.reload();
				}
			}
		};

		let request;


		if (!shouldUseLocalCart) {
			requestBody = `{
				customerCart {
				  id
				}
			  }`;
			const query = JSON.stringify({
				query: requestBody,
			});
			request = await _makePostRequest(query, credentials.INCLUDE).then(afterRequestSteps);
		} else {
			console.log("Anonymous Cart in use");

			while (Utils.getCookie('commerce-cart-id') == null) {
				await new Promise(r => setTimeout(r, 500));
			}

			let localCartId = Utils.getCookie('commerce-cart-id');
			requestBody = `{
							cart(cart_id: "${localCartId}") {
								id
							}
						}`;
			const query = JSON.stringify({
				query: requestBody,
			});
			request = await _makePostRequest(query, credentials.INCLUDE).then(afterRequestSteps);
		}
		return request;
	};

	const _isLoggedIn = () => {
		return Utils.getCookie('m2cid') !== null;
	}

	/* Create Empty Cart */
	const _createEmptyCart = async () => {
		const requestBody = 'mutation {createEmptyCart}';
		const query = JSON.stringify({
			query: requestBody
		});

		const request = await _makePostRequest(query).then((response) => {
			Utils.setCookie('commerce-cart-id', response.data.createEmptyCart, 1, 'Lax');
			Utils.setCookie('local-cart', true, 1, 'Lax');
			return response.data.createEmptyCart;
		});

		return request;
	};

	/* Remove Item From Cart */
	const _removeItemFromCart = async (cartItemId) => {
		const cartId = Utils.getCookie('commerce-cart-id');
		// Trigger cart update window event
		$(window).trigger(cartAction);

		// If no cartId or no cartItemId.
		if (!cartId || !cartItemId) {
			return Promise.resolve('Need cartId and cartItemId.');
		}

		const requestBody = `mutation removeItemFromCart($cartId: String!, $cartItemId: Int!) {
			removeItemFromCart(input: { cart_id: $cartId, cart_item_id: $cartItemId }) {
				cart {
					${cartInterface}
				}
			}
		}`;

		const variablesObj = {
			cartId,
			cartItemId,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequest(query, credentials.INCLUDE);

		/* eslint-disable-next-line no-console */
		console.log('removeItemFromCart', request);

		// Update local storage
		lastActionTaken = 'remove';
		_getCart(cartId);

		return request;
	};

	/* Update Item From Cart */
	const _updateItemInCart = async (cartItemId, quantity) => {
		const cartId = Utils.getCookie('commerce-cart-id');

		// Trigger cart update window event
		$(window).trigger(cartAction);

		// If no cartId, cartItemId and cartItemQuantity.
		if (!cartId || !cartItemId || !quantity) {
			return Promise.resolve('Need cartId, cartItemId and quantity.');
		}

		const requestBody = `mutation updateCartItem(
			$cartId: String!
			$cartItemId: Int!
			$quantity: Float!
		) {
			updateCartItems(
				input: {
					cart_id: $cartId
					cart_items: [{ cart_item_id: $cartItemId, quantity: $quantity }]
				}
			) {
				cart {
					${cartInterface}
				}
			}
		}`;

		const variablesObj = {
			cartId,
			cartItemId,
			quantity,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequest(query, credentials.INCLUDE);

		// Update local storage
		lastActionTaken = 'update';
		_getCart(cartId);

		return request;
	};

	/* Add Item To Cart */
	const _addItemToCart = async (productObject) => {
		let cartId = Utils.getCookie('commerce-cart-id');
		let cartObject = productObject;
		//console.log('adding following to the cart');
		//console.log(cartObject);
		// saving item for carts merge after logging in

		// Trigger cart update window event
		$(window).trigger(cartAction);

		// Set cart item Name for message bar
		lastActionTaken = 'add';
		lastItemAdded = cartObject.productName;
		// Utils.setCookie('commerce-item-message', cartObject.productName);

		// If no cartId, create one.
		if (!cartId) {
			const cart = await _getCart('');
			cartId = cart.data.cart.id;
		}

		cartObject = {
			...cartObject,
			cartId,
		};

		/* eslint-disable-next-line no-console */
		console.log('addItemToCart cartId', cartObject);

		let request;

		switch (cartObject.productType) {
			case 'simple':
				request = await _addSimpleProduct(cartObject);
				break;
			case 'configurable':
				request = await _addSimpleProduct(cartObject);
				break;
			case 'bundle':
				request = await _addBundleProduct(cartObject);
				break;
			default:
		}

		if (request && request.errors) {
			return request;
		}

		const cart = await _getCart(cartId);
		$(window).trigger(cartUpdate);
		return cart;
	};

	/* Get Cart Total Quantity */
	const _getCartQuantity = async () => {

		let localCart = $.parseJSON(Utils.getLocalStorage('commerce-cart-storage'));

		// if no cart storage then create one
		if (!localCart) {
			await _getCustomerDetails();
			await _getCart('');
			localCart = $.parseJSON(
				Utils.getLocalStorage('commerce-cart-storage')
			);
		}

		let cartQuantity = 0;

		if (localCart && localCart.data.cart.items.length > 0) {
			cartQuantity = localCart.data.cart.items
				.map((item) => {
					return item.quantity ? parseInt(item.quantity) : parseInt(item.productQuantity);
				})
				.reduce((prev, next) => {
					return prev + next;
				});
		}
		return cartQuantity;
	};

	/* Get Product Alerts */
	const _getProductAlerts = async () => {
		const requestBody = `{
			  productAlert {
				 product_id
				 status
			  }
		   }`;

		const request = await _makeGetRequest(
			requestBody,
			'',
			credentials.INCLUDE
		);
		return request;
	};

	/* Add Product Alert */
	const _addProductAlert = async (productId) => {
		// Catch no productId.
		if (!productId) {
			return Promise.resolve('Need productId.');
		}

		const requestBody = `mutation productAlertCustomerNotifyInStock(
			$productId: Int!
		) {
			productAlertCustomerNotifyInStock(
				input: {
					productId: $productId
				}
			) {
				product_id
				status
			}
		}`;

		const variablesObj = {
			productId,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequest(query, credentials.INCLUDE);
		return request;
	};

	const _addProductReview = async (reviewObject) => {
		const ratings = reviewObject.ratings.reduce(
			(acc, cur) =>
				`${acc}{id: "${cur.id}", value_id: "${cur.value_id}"},`,
			''
		);

		const product_variant_options = reviewObject?.product_variant_options?.reduce(
			(acc, cur) => 
				`${acc}{option_id: ${cur.option_id}, product_id: ${cur.product_id}},`,
				''
		)

		
		const requestBody = product_variant_options ? `
				mutation {
					createProductReview (
						input: {
							sku: "${reviewObject.sku}",
							nickname: "${reviewObject.nickname}",
							summary: "${reviewObject.summary}",
							text: "${reviewObject.text}",
							ratings: [${ratings}],
							product_variant_options: [${product_variant_options}] 
						}
					) {
					review {
						nickname
						summary
						text
						average_rating
						ratings_breakdown {
							name
							value
						}
					}
				}
			}
		` : 
        `
				mutation {
					createProductReview (
						input: {
							sku: "${reviewObject.sku}",
							nickname: "${reviewObject.nickname}",
							summary: "${reviewObject.summary}",
							text: "${reviewObject.text}",
							ratings: [${ratings}],
						}
					) {
					review {
						nickname
						summary
						text
						average_rating
						ratings_breakdown {
							name
							value
						}
					}
				}
			}
		`


		const query = JSON.stringify({
			query: requestBody,
		});

		const request = await _makePostRequest(query, credentials.SAMEORIGIN);
		return request;
	};

	const _getProductReviews = async (productID) => {
		// Catch no productId.
		if (!productID) {
			return Promise.resolve('Need Product Id.');
		}
		const requestBody = `{
		    products(
		        filter: { sku: {eq: "${productID}"} }
		    ) {
		        items {
					${productReviewsInterface}
		        }
		    }
		}`;
		const request = await _makeGetRequest(requestBody);
		return request;
	};

	/* Get Customer Details */
	const _getCustomerDetails = async () => {
		const requestBody = `{
			customer {
			firstname
			lastname
			suffix
			email
			dob
			gender
			gigya_id
			velo_member_id
			glo_member_id
			gloid
			channel_name
			has_glo_velo_orders
			glo_velo_history_check {
				velo_jp_consumable 
			}
			subscription {
				has_subscription
			}
			addresses {
			firstname
			lastname
			street
			city
			region {
			  region_code
			region
			}
			postcode
			country_code
			telephone
			}
			}
			}`;

		const query = JSON.stringify({
			query: requestBody,
		});

		const request = await _makeGetRequest(requestBody, "", credentials.INCLUDE);
		console.log('end details');
		if(request && !request.errors){
			Utils.setLocalStorage('hasSubscription', request.data.customer.subscription.has_subscription);
			Utils.setLocalStorage('hasGloVeloOrders', request.data.customer.has_glo_velo_orders);
			Utils.setLocalStorage('gloVeloHistoryCheck', request.data.customer.glo_velo_history_check);
			
		}
        return request;
	};

// save basket exclusivity items for later
	const _getExclusivityItems = async (cartObject) => {

		const requestBody = `mutation saveBasketExclusivityItemsForLater(
			$cartId: String!
			$itemType: String!
		) {
			moveCartItemsToPendingCart(
				input: {
					cart_id: $cartId,
					item_type: $itemType
				}
			) {
				cart {
					items {
						id
							product {
							name
							sku
							}
						quantity
					}
				}
				}
			}`;

		const variablesObj = {
			cartId: cartObject.cartId,
			itemType: cartObject.itemType,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequest(query, credentials.INCLUDE);

		return request;
	};

	// save basket exclusivity items for later new graphql
    const _getExclusivityItemsAem = async (cartObject) => {
        const requestBody = `mutation splitCart(
            $cartId: String!
            $itemType: String!
        ) {
            splitCart(
                input: {
                    cart_id: $cartId,
                    item_type: $itemType
                }) {
                cart {
                    items {
                        id
                        product {
                            name
                            sku
                        }
                        quantity
                    }
                }
                pending_cart_id
            }
        }`;

        const variablesObj = {
            cartId: cartObject.cartId,
            itemType: cartObject.itemType,
        };

        const query = JSON.stringify({
            query: requestBody,
            variables: variablesObj,
        });

        const request = await _makePostRequest(query, credentials.INCLUDE);

        return request;
    };

	const _checkIfEligible = async (productId, campaignType, level) => {
		console.log("inside check eligible method", campaignType);
		if (level === 0) {
			levelValue = 'level:0';
		} else if (level === 1) {
			levelValue = 'level:1';
		} else {
			levelValue = 'level:2';
		}
		let requestBody;
		if (campaignType == 'NJC') {
			 requestBody = `query {
				newJoinerCampaign(product_id: ${productId}, ${levelValue}) {
					is_allowed
					url
					message
				}
			}`;
		}else if(campaignType == 'PRELAUNCH') {
			 requestBody = `query {
				preLaunchCampaign(product_id: ${productId}, ${levelValue}) {
					is_allowed
					url
					message
				}
			}`;
		}else if(campaignType == 'AIR') {
			requestBody = `query {
				f1LotteryCampaign(product_id: ${productId}) {
					is_allowed
					url
					message
				}
			}`;
		}
		const request = await _makeGetRequest(requestBody, "", credentials.INCLUDE).then((response) => {
			return response;
		});

		return request;
	}

	const _sendQuizStatus = async (sessionId, answers, isFinished = 0) => {
		const requestBody = `
							mutation {
							  updateJpGuidedSellResponse(
								input: {
								  session_id: ${sessionId}
								  ${answers !== null ? `reason_indices : ${answers}` : ``}
								  ${isFinished !== 0 ? `finished: true` : ``}
								}
							  ) {
								device
								device_description
								finished
								filters {
								  attribute_code
								  category_id
								  options
								}
							  }
							}`;
		const query = JSON.stringify({
			query: requestBody
		});
		const request = await _makePostRequest(query, credentials.INCLUDE).then((response) => {

			return response;
		});


		return request;
	}

	const _getQuizQuestions = async (el) => {
		const requestBody = `query {
		  					moduleConfig {
								jp_guided_sell {
								  enabled
								  configuration {
									questions {
									  question
									  options
									}
								  }
								}
							  }
							}`;
		const query = JSON.stringify({
			query: requestBody
		});
		const request = await _makePostRequest(query, credentials.INCLUDE).then((response) => {
			return response;
		});

		return request;
	}

	const _mapProduct = (product) => {
		function formatPriceString(priceObject) {
			return {
				...priceObject,
				value: typeof priceObject?.value === 'string' ? priceObject?.value : _priceFormatter(priceObject?.value, priceObject?.currency),
			};
		}

		let small_image;
		switch (product.type_id) {
			case 'configurable':
				small_image = product?.variants[0].product.small_image;
				break;
			case 'bundle':
				small_image = product.small_image || product.items[0].options[0].product.small_image;
				break;
			default:
				small_image = product.small_image;
		}

		let price_range = {
			final_price: formatPriceString(product.price_range?.minimum_price?.final_price),
		};

		if (product.price_range?.minimum_price?.discount?.amount_off) {
			price_range = {
				final_price: formatPriceString(product.price_range?.minimum_price?.final_price),
				regular_price: formatPriceString(product.price_range?.minimum_price?.regular_price),
			};
		}

		if (product.type_id === 'bundle' && product.jp_bundle_regular_price) {
			price_range = {
				...price_range, regular_price: formatPriceString({
					value: product.jp_bundle_regular_price,
					currency: product.price_range?.minimum_price?.final_price?.currency,
				}),
			};
		}

		return {
			price_range,
			show_notify_button: product.jp_campaign_any !== true ? (product.type_id !== 'bundle' && product.stock_status === 'OUT_OF_STOCK' && !product.notification_set):"",
			show_notify_set_button: product.jp_campaign_any !== true ? (product.type_id !== 'bundle' && product.stock_status === 'OUT_OF_STOCK' && product.notification_set):"",
			show_link_button: (product.type_id === 'bundle') || (product.stock_status !== 'OUT_OF_STOCK' && product?.variants && product?.variants.length > 5),
			show_cart_button: product.jp_campaign_any !== true ? (product.stock_status !== 'OUT_OF_STOCK' && product.type_id !== 'bundle') || (product.stock_status !== 'OUT_OF_STOCK' && product?.variants && product?.variants.length <= 5):"",
			show_product_button: ((product.jp_campaign_any == true && product.type_id !== 'bundle') && product.jp_campaign_pre_launch !== true),
			show_preorder_button: ((product.jp_campaign_any == true && product.type_id !== 'bundle') && product.jp_campaign_pre_launch === true), // {{ Applicable for Prelaunch Product}}
			showFragrance: Object.keys(product).some((key) => key.includes('glo_strength_fragnance') && !!product.glo_strength_fragnance),
			showTobacco: Object.keys(product).some((key) => key.includes('glo_strength_tobacco') && !!product.glo_strength_tobacco),
			showStrengthMenthol: Object.keys(product).some((key) => key.includes('glo_strength_menthol') && !!product.glo_strength_menthol),
			showStrengthIntake: Object.keys(product).some((key) => key.includes('glo_strength_intake') && !!product.glo_strength_intake),
			small_image,
		};	
	}

	const _mapSelected = (products) => {
		console.log('map selected in commerce');
		return products.map((product) => {
			const selectedVariant = product?.variants && product?.variants.find((variant) => !!variant.product.glo_jp_colour);
			const selectedProduct = (selectedVariant && selectedVariant.product) || product;
			return {
					...selectedProduct, 
			        selectedProduct: {
					...selectedProduct, ..._mapProduct(selectedProduct),

				},
			};
		});
	}

	//xIntense modal product load and logic 
	const  _openRcommendenProductModal = async (suggestedSKU) => {
		const modalEl = $('#recommondedsku');
		modalEl.css('padding-top','20px');
		const closeButton = document.querySelector('#recommondedsku .bat-form-toast_wrapper-toast-right-closebutton');
		closeButton.addEventListener("click", () => {
			modalEl.hide();
		});
		const productLoadingProgress = $('.bat-productdetails .loader-container');
		$('#recommondedsku .bat-cta-style.bat-modal-close').hide();
		productLoadingProgress.show();
		let productsData = await _getProduct(suggestedSKU).then((response) => response.data);
		let filteredSKU = productsData?.products.items.filter(
			(p) => p.sku === suggestedSKU
		);
		productLoadingProgress.hide();
		console.log('recommendedProduct2' + productsData);
		console.log('filtered product2' + filteredSKU);
		let productDetailsData = document.querySelector('bat-card-productdetails').data;
		let items = _mapSelected(filteredSKU);
		productDetailsData.items = items;
		document.querySelector('bat-card-productdetails').setAttribute("data-model", JSON.stringify(productDetailsData));
		$('#goToRecommendedProduct').attr('href', $('.bat-productdetails .bat-productlistings-card-name a').attr('href'));
		document.querySelector('#recommondedsku .bat-form-toast_wrapper-toast-right-closebutton').addEventListener("click", () => {
			modalEl.hide();
		});
	}

	_constructor();

// output/public
	return {
		isLoggedIn: _isLoggedIn,
		createEmptyCart: _createEmptyCart,
		addItemToCart: _addItemToCart,
		updateItemInCart: _updateItemInCart,
		getCart: _getCart,
		getCartId: _getCartId,
		getCartQuantity: _getCartQuantity,
		removeItemFromCart: _removeItemFromCart,
		getProduct: _getProduct,
		priceFormatter: _priceFormatter,
		getProductCatalog: _getProductCatalog,
		getCategoryList: _getCategoryList,
		getProductAlerts: _getProductAlerts,
		addProductAlert: _addProductAlert,
		addProductReview: _addProductReview,
		getProductReviews: _getProductReviews,
		getCustomerDetails: _getCustomerDetails,
		getExclusivityItems: _getExclusivityItems,
		getExclusivityItemsAem: _getExclusivityItemsAem,
		getStoreConfig: _getStoreConfig,
		checkIfEligible: _checkIfEligible,
		sendQuizStatus: _sendQuizStatus,
		getQuizQuestions: _getQuizQuestions,
		makePostRequest: _makePostRequest,
		mapProduct: _mapProduct,
		mapSelected: _mapSelected,
		openRcommendenProductModal: _openRcommendenProductModal
	};
})
();
// document.dispatchEvent(new CustomEvent('commerce.load'));